import { Link } from 'react-router-dom';
import { recommendations } from '@/mocks/episodes';

export default function HotRecommendations() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-900/60 border-y border-primary-900/40">
      <div className="mb-8">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">热门推荐 · 同类型动漫</h2>
        <p className="mt-2 text-sm text-foreground-400">
          喜欢「无颜之月」的你，也许会被这些同样带着夜色的故事打动
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {recommendations.map((item) => (
          <Link
            key={item.id}
            to="/category"
            className="group flex flex-col cursor-pointer"
          >
            <div className="relative w-full h-56 md:h-64 rounded-lg overflow-hidden border border-primary-900/40 group-hover:border-primary-500/60 transition-colors">
              <img
                src={item.cover}
                alt={`${item.title} 动漫海报`}
                title={`${item.title} 动漫推荐`}
                className="w-full h-full object-top object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent"></div>
              <span className="absolute top-2 right-2 flex items-center gap-1 rounded-md bg-background-950/80 backdrop-blur px-2 py-0.5 text-xs font-semibold text-accent-400">
                <i className="ri-star-fill"></i>
                {item.rating}
              </span>
            </div>
            <h3 className="mt-3 font-heading text-sm font-semibold text-foreground-50 group-hover:text-accent-400 transition-colors line-clamp-1">
              {item.title}
            </h3>
            <p className="mt-0.5 text-xs text-secondary-300">{item.genre}</p>
            <p className="mt-1 text-xs text-foreground-400 leading-relaxed line-clamp-2">{item.desc}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}